import { useCohort } from '@/components/user-context/helpers/cohorts.ts';
import { useIsMobile } from '@/utils/useIsMobile';

import { SignupDefault } from '../../../components/signup-default';
import { LoggedInLoomExistingSitesUser } from '../existing-sites-user';
import { LoggedInLoomNewUser } from '../new-user';

export const LoggedInLoom = () => {
	const cohort = useCohort();
	const isMobile = useIsMobile(800);

	// Default cohorts not part of loom lofi background
	if (cohort === undefined) {
		return null;
	} else if (
		cohort === 'managed-user' ||
		cohort === 'week-one-user' ||
		cohort === 'upgrade-eligible-user'
	) {
		return <SignupDefault />;
	} else if (isMobile) {
		return <SignupDefault />;
	}

	if (cohort === 'new-user') {
		return <LoggedInLoomNewUser />;
	}

	return <LoggedInLoomExistingSitesUser />;
};
